module.exports = __webpack_public_path__ + "static/media/national-2-web-bold.1a8cf9fa.woff2";